import './DesktopOnly.css'

/**
 * A screen that deliberately does not exist on a phone.
 *
 * The designer blocks four of them — Newsletter and Email automation under both
 * products, plus Admin — and the reasoning is worth keeping visible, because
 * "make it responsive" would quietly undo it:
 *
 *   "Sending and template editing need more space. Open this page on a computer
 *    to continue."
 *
 * That is the polite version. The real one is that the newsletter screen is the
 * one place in this tool where a mistap reaches 44,233 people, and a cramped
 * layout with a confirm button near a thumb is how that happens. The send path
 * has its own guards — a required test tied to a content hash, a typed
 * recipient count — but a guard you can defeat by being on the wrong device at
 * the wrong moment is worth not needing.
 *
 * Admin is blocked for the same class of reason: it edits pipeline stages and
 * templates that every other screen reads.
 *
 * This is not a "coming soon". Nothing is coming; the screen works, elsewhere.
 */
export function DesktopOnly({ title }: { title: string }) {
  return (
    <div className="desktoponly">
      <div className="desktoponly__icon" aria-hidden="true">
        🖥
      </div>
      <div className="desktoponly__title">{title} works best on desktop</div>
      <p className="desktoponly__note">
        Sending and template editing need more space. Open this page on a computer to continue.
      </p>
    </div>
  )
}
